import React, { useState, useEffect } from "react";
import { Typography } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import api from "../../services/api";
import ProjectsTable from "./components/ProjectsTable";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
  },
  emptyContainer: {
    padding: theme.spacing(2),
    minHeight: "200px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default function TempoConfiguration({ id }) {
  const classes = useStyles();
  const [projects, setProjects] = useState([]);
  const [isTempoEnabled, setIsTempoEnabled] = useState(false);
  const [screensEnabled, setScreensEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function getProjects(accountId) {
      try {
        const accessToken = localStorage.getItem("idToken");
        const feats = await api.getAccountFeatures({ accountId, accessToken });

        if (!feats.tempo || !feats.tempo.enabled) {
          setIsTempoEnabled(false);
          setIsLoading(false);
          return;
        }

        if(feats.screens && feats.screens.enabled){
          setScreensEnabled(true);
        }

        const headers = { Authorization: `Bearer ${accessToken}` };
        const response = await fetch(`/service/${accountId}/projects`, {
          headers,
        });
        const projects = await response.json();
        setIsTempoEnabled(true);
        setProjects(projects);
        setIsLoading(false);
      } catch (error) {
        console.log(error);
      }
    }

    getProjects(id);
  }, []);

  function renderProjectsTable() {
    // When Loading
    if (isLoading) {
      return (
        <Paper className={classes.emptyContainer}>
          <Typography variant="h5">Loading...</Typography>
        </Paper>
      );
    }

    // When Tempo is disabled
    if (!isTempoEnabled) {
      return (
        <Paper className={classes.emptyContainer}>
          <Typography variant="h5">
            Tempo is not enabled for this Account.
          </Typography>
        </Paper>
      );
    }

    // When there are no Projects
    if (!projects.length) {
      return (
        <Paper className={classes.emptyContainer}>
          <Typography variant="h5">This Account has no Projects.</Typography>
        </Paper>
      );
    }

    return (
      <Paper className={classes.container}>
        <ProjectsTable projects={projects} accountId={id} screensEnabled={screensEnabled} />
      </Paper>
    );
  }

  return (
    <>
      <label className="box-label">Tempo Configuration</label>
      {renderProjectsTable()}
    </>
  );
}
